/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_House_Promo_LabelInputs */

const en_directory_house_promo_label = /** @type {(inputs: Directory_House_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From our team`)
};

const zh_directory_house_promo_label = /** @type {(inputs: Directory_House_Promo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们团队的产品`)
};

/**
* | output |
* | --- |
* | "From our team" |
*
* @param {Directory_House_Promo_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_house_promo_label = /** @type {((inputs?: Directory_House_Promo_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_House_Promo_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_house_promo_label(inputs)
	return zh_directory_house_promo_label(inputs)
});
export { directory_house_promo_label as "directory.house_promo.label" }